import type { TransportItem } from '@grafana/faro-react';

const REDACTED = '[REDACTED]';

const SECRET_PATTERNS: RegExp[] = [
  /Bearer\s+[A-Za-z0-9._-]+/gi,
  /tgWebAppData=[^&\s]+/gi,
  /init[_-]?data=[^&\s]+/gi,
  /signature=[^&\s]+/gi,
  /hash=[^&\s]+/gi,
  /(authorization|token|access[_-]?token|api[_-]?key)["':=\s]+[^&\s"']+/gi,
];

export function scrubString(value: string): string {
  return SECRET_PATTERNS.reduce((acc, re) => acc.replace(re, REDACTED), value);
}

export function scrubUrl(value: string): string {
  try {
    const url = new URL(value);
    url.search = '';
    // Launch parameters live in the URL fragment; keep normal HashRouter routes.
    if (/tgWebApp|init[_-]?data[=%]/i.test(url.hash)) url.hash = '';
    const result = url.toString();
    const pathWithoutSlash = url.pathname === '/' && !value.split(/[?#]/)[0].endsWith('/');
    return pathWithoutSlash ? result.replace(/\/(?=#|$)/, '') : result;
  } catch {
    return scrubString(value);
  }
}

export function scrubFaroItem(item: TransportItem): TransportItem | null {
  try {
    const json = JSON.stringify(item, (key, val: unknown) => {
      if (
        /^(?:authorization|token|accessToken|access_token|initData|init_data|rawInitData|tgWebAppData|hash|signature)$/i.test(
          key
        )
      ) {
        return REDACTED;
      }
      if (typeof val !== 'string') return val;
      if (/^https?:\/\//i.test(val)) return scrubUrl(val);
      if (/url|href|target/i.test(key)) return scrubUrl(val);
      return scrubString(val);
    });
    return JSON.parse(json) as TransportItem;
  } catch {
    // If we cannot scrub an item, do not send the original credentials to telemetry.
    return null;
  }
}
